import { AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  all: () => axios.get('/api/logger')
})
